// extracted by mini-css-extract-plugin
module.exports =  {"editor":"WVVwHouDWkCh8CdNHjwy"};